export default "__VITE_ASSET__17ebee6f__"